import React from 'react';
import PropTypes from 'prop-types';

var StepWrapper = function StepWrapper(_ref) {
  var backgroundImage = _ref.backgroundImage,
      stepClassNames = _ref.stepClassNames,
      children = _ref.children,
      isDesktop = _ref.isDesktop;
  return /*#__PURE__*/React.createElement("div", {
    className: "step ".concat(stepClassNames),
    style: backgroundImage && isDesktop ? {
      backgroundImage: "url(".concat(backgroundImage, ")")
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__content"
  }, children)));
};

StepWrapper.propTypes = {
  backgroundImage: PropTypes.string,
  stepClassNames: PropTypes.string,
  children: PropTypes.node.isRequired,
  isDesktop: PropTypes.bool
};
StepWrapper.defaultProps = {
  backgroundImage: '',
  stepClassNames: '',
  isDesktop: false
};
export default StepWrapper;